import ModalVariants from './ModalVariants.component';
export default ModalVariants;